// import connect from "../node_modules/connect/index.js";
import "../index.css";
import "./auth.css";
import { checkFullscreen } from "../component/checkFullscreen.js";
import "../component/fixConsoleLog.js";
import {
  validNumberFromGet,
  showAlert,
  safeFetch,
} from "../component/functionFromExport.js";
import {
  getWebApp,
  getChatId,
  getPlatform,
  getBotLink,
  showBackButton,
  hideBackButton,
  onBackButton,
  loadRuntimeConfig,
} from "../component/clientState.js";

import logo from "../image/logo.svg";

document.getElementById("logo").src = logo;
loadRuntimeConfig();

let input = document.getElementById("phoneNumber");
let iti = 0;

const form = document.querySelector("#login");
const message = document.querySelector("#message");
const showCheckField = document.getElementById("checkField");
const WebApp = getWebApp();

const displayPreloader = document.querySelector(".preloader");
const getMainClass = document.querySelector(".main");

let chatId = getChatId(); // id пользователя платформы (для CRM как chatId/tg_id)

const randCheckCode = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
const getCheck = document.getElementById("btn");
let letPhoneNumber = "";

let PhoneClient = "";
const checkCode = document.getElementById("sendCode");

if (window.location.pathname == "/auth/") {
  showBackButton();
}

checkFullscreen(true, WebApp);


window.onload = () => {
  displayPreloader.style.display = "none";
  getMainClass.style.filter = "none";
  // console.info("done");
};

onBackButton(function () {
  if (window.location.pathname != "/schedule/") {
    history.back();
  }
  hideBackButton();
});

if (showCheckField != null) {
  showCheckField.addEventListener("input", function (e) {
    var inp = event.target;
    var inps = this.querySelectorAll("input");
    var value = Array.prototype.map.call(inps, (x) => x.value).join("");
    var i = +inp.dataset.start + inp.selectionStart,
      pos = value.length;

    for (var q = 0; q < inps.length; ++q) {
      var start = +inps[q].dataset.start,
        len = +inps[q].dataset.len;
      inps[q].value = value.substr(start, len);

      if (start + len >= i) {
        inp = inps[q];
        pos = i - start;
        i = NaN;
      }
    }

    inp.focus();
    inp.selectionStart = inp.selectionEnd = pos;
  });
}
// const output = document.querySelector(".iti");

const resolveLocaleCountry = () => {
  const lang = navigator.language || navigator.userLanguage;
  if (!lang) return null;
  const parts = lang.split("-");
  return parts[1] ? parts[1].toLowerCase() : null;
};

const geoIpLookup = (callback) => {
  const fallback = resolveLocaleCountry() || "ru";
  fetch("https://ipapi.co/json/")
    .then((res) => (res.ok ? res.json() : Promise.reject()))
    .then((data) => callback(data?.country_code?.toLowerCase() || fallback))
    .catch(() => {
      fetch("https://ipwho.is/")
        .then((res) => (res.ok ? res.json() : Promise.reject()))
        .then((data) => callback(data?.country_code?.toLowerCase() || fallback))
        .catch(() => callback(fallback));
    });
};

if (input != null) {
  input.addEventListener("paste", function () {
    input.value = "";
  });

  iti = intlTelInput(input, {
    nationalMode: false,
    initialCountry: "auto",
    strictMode: true,
    separateDialCode: true,
    autoPlaceholder: "off",
    geoIpLookup,
    utilsScript: "/node_modules/intl-tel-input/build/js/utils.js",
  });
  input.addEventListener("paste", function () {
    setTimeout(() => {
      iti.setNumber(input.value, { nationalMode: true });
    }, 50);
  });
}

// let resultBoolCheckCode = false;

function sendCheckCode(callback) {
  displayPreloader.style.display = "flex";
  getMainClass.style.filter = "blur(5px)";
  safeFetch("/sendcode", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      codeFromClient: randCheckCode,
      chatId: chatId,
      platform: getPlatform(),
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      displayPreloader.style.display = "none";
      getMainClass.style.filter = "none";
      if (callback) {
        callback(data);
      }
      if (data.ok) {
        message.textContent = "Подтверждение кода отправлено";
      } else {
        message.innerHTML = `Пользователь не авторизован в <a href="${getBotLink()}" target="_blank" rel="noopener" class="tooltip">боте</a>`;
      }
    })
    .catch((err) => {
      console.error(err);
      message.textContent = "Возникла ошибка при отправке кода";
    });
}

// обратный отсчет на повторную отправку проверочного кода

if (checkCode != null) {
  checkCode.setAttribute("disabled", "");
  checkCode.style.cursor = "not-allowed";
}
function timerCountDown() {
  let time = 60;
  const timer = setInterval(() => {
    let timedown = document.getElementById("countdown");
    if (time === 0) {
      timedown.innerText = "";
      checkCode.removeAttribute("disabled");
      checkCode.style.cursor = "pointer";
      clearInterval(timer);
    } else {
      timedown.innerText = time--;
    }
  }, 1000);
}
// }
const sendCheckCodeButton = document.getElementById("sendCode");

if (sendCheckCodeButton != null) {
  sendCheckCodeButton.addEventListener("click", () => {
    sendCheckCode();
    checkCode.setAttribute("disabled", "");
    timerCountDown();
  });
}

function checkPhoneNumber(letPhoneNumber, PhoneClient) {
  return (
    validNumberFromGet(letPhoneNumber) === validNumberFromGet(PhoneClient)
  );
}

const comparionTgNumberAndYc = (client) => {
  let res = false;
  const phoneDigits = validNumberFromGet(PhoneClient);
  const currentTgId = String(getChatId() || chatId || "");

  client.forEach((element, index) => {
    if (index === 0 && element.tg_id_current_user) {
      chatId = element.tg_id_current_user;
    }

    if (
      element.tg_phone_plus &&
      validNumberFromGet(element.tg_phone_plus) === phoneDigits
    ) {
      res = true;
    }

    if (
      element.tg_id_current_user &&
      String(element.tg_id_current_user) === currentTgId
    ) {
      res = true;
    }
  });
  return res;
};

const getClientFunc = (obj, callback) => {
  safeFetch("/client", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),
  })
    .then((response) => response.json())
    .then((data) => {
      const clients = Array.isArray(data) ? data : [data];
      localStorage.setItem(
        "clientGroupId",
        clients[0].client_group_id_wout_letter,
      );
      localStorage.setItem(
        "_yc_id",
        clients[0].client_yc_id,
      );
      if (callback) {
        callback(clients);
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

if (getCheck != null) {
  getCheck.addEventListener("click", (e) => {
    // отправка формы
    e.preventDefault();
    if (!iti.isValidNumber() || input.value <= 0) {
      message.innerHTML = "Неверный номер телефона"; // если номер телефона не корректный
      input.style.border = "1px solid red";
      message.classList.add("errText");
      displayPreloader.style.display = "none";
      getMainClass.style.filter = "none";
      return;
    }
    letPhoneNumber = document.querySelector(
      ".iti__selected-dial-code",
    ).innerText;
    letPhoneNumber += document.getElementById("phoneNumber").value;

    let phoneNumberFromGet = validNumberFromGet(letPhoneNumber);

    const objectClient = {};
    objectClient["clientPhone"] = phoneNumberFromGet;
    objectClient["chatId"] = chatId;

    // objectClient["clientGroupId"] = clientGroupId;
    displayPreloader.style.display = "flex";
    getMainClass.style.filter = "blur(5px)";
    getClientFunc(objectClient, (data) => {
      // checkPhoneFromTgAndLk = comparionTgNumberAndYc(data);
      PhoneClient = data[0].client_phone;
      displayPreloader.style.display = "none";
      getMainClass.style.filter = "none";
      message.classList.remove("errText");
      message.textContent = "";
      input.style.border = "none";

      if (checkPhoneNumber(letPhoneNumber, PhoneClient)) {
        if (!comparionTgNumberAndYc(data)) {
          sendCheckCode((data) => {
            if (data.ok) {
              clientIsLogin(validNumberFromGet(letPhoneNumber), "confirm", getChatId())
              showCheckField.style.display = "block";
              getCheck.style.display = "none";
              getMainClass.style.filter = "none";
              timerCountDown();
            } else {
              clientIsLogin(validNumberFromGet(letPhoneNumber), "user_unauth", getChatId())
            }
          });
        } else {
          // fetch(`/loginHash?phone=${validNumberFromGet(letPhoneNumber)}`)
          // .then((responce) => responce.text())
          // .then((data) => {
          //   console.info(data);
          // })
          clientIsLogin(validNumberFromGet(letPhoneNumber), "auth", getChatId());
          localStorage.setItem("phoneNumber", `${letPhoneNumber}`);
          // Keep platform across hash-less navigation after login
          getPlatform();
          window.location.href = "/";
        }
      } else {
        e.preventDefault(); // если номер телефона не найден в базе
        clientIsLogin(validNumberFromGet(letPhoneNumber), "user_unexist", getChatId())
        showAlert(
          "Вы не зарегистрированы, проверьте введеный номер телефона или обратитесь к менеджеру",
        );
      }
    });
  });
}

function clientIsLogin(phone, string, tgId) {
  safeFetch("/isLogin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ clientPhone: phone, type: string, tgId: tgId }),
  })
    .then((response) => response.text())
    .then((data) => {
      // console.info(data);
    })
}

// function clientError(phone, string, idTg) {
//   fetch("/isLogin", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ clientPhone: phone, type: "error", error: string, tgId: idTg }),
//   })
//     .then((response) => response.text())
//     .then((data) => {
//       console.info(data);
//     })

// }

function checkCodeValid() {
  // проверка проверочного кода
  // получаем данные из полей ввода
  const checkInput1 = document.getElementById("checkInput1").value;
  const checkInput2 = document.getElementById("checkInput2").value;
  const checkInput3 = document.getElementById("checkInput3").value;
  const checkInput4 = document.getElementById("checkInput4").value;

  let chIn1 = Math.floor(randCheckCode / 1000);
  let chIn2 = Math.floor((randCheckCode / 100) % 10);
  let chIn3 = Math.floor((randCheckCode / 10) % 10); // в эти переменные получим из кода который отправили
  let chIn4 = Math.floor(randCheckCode % 10);

  if (
    checkInput1 == chIn1 &&
    checkInput2 == chIn2 &&
    checkInput3 == chIn3 &&
    checkInput4 == chIn4
  ) {
    return true;
  } else {
    return false;
  }
}

const sendForm = document.getElementById("confirm");

if (sendForm != null) {
  sendForm.addEventListener("click", (e) => {
    e.preventDefault();
    if (checkCodeValid()) {
      clientIsLogin(validNumberFromGet(letPhoneNumber));
      localStorage.setItem("phoneNumber", letPhoneNumber);
      getPlatform();
      window.location.href = "/";
    } else {
      showAlert("Неверный код");
    }
  });
}
